import { useTheme } from "@mui/material";
import { useMemo, useState } from "react";
function usePopperProps(state, $root) {
  const [popperRef, setPopperRef] = useState(() => null);
  const {
    zIndex: { tooltip: zIndex }
  } = useTheme();
  const { open } = state;
  const popperProps = useMemo(
    () => ({
      ref: setPopperRef,
      open,
      anchorEl: $root,
      style: {
        zIndex
      }
    }),
    [$root, open, zIndex]
  );
  return {
    popperProps,
    popperRef
  };
}
export {
  usePopperProps
};
//# sourceMappingURL=usePopperProps.js.map
